<template>
  <transition name="fade" appear>
    <div class="home-page-view content-wrapper" id="home-page-view" ref="root">
      <MainMenu v-if="isHeaderVisible" pageTitle="Profile">
        <template slot="secondary-menu">
          {{ JSON.stringify(trips) }}
        </template>
      </MainMenu>

      <div class="mobile-wrapper">
        <div class="mobile-overlay">
          <div class="img"></div>
          <div class="text-primary"><b>Access site from your desktop browser</b></div>
          <div class="text-secondary">
            Mobile devices are currently not supported. Plan your next trip from your web browser on your computer or
            laptop.
          </div>
        </div>

        <PoweredByMobi class="powered-by-mobi-position" v-if="showPoweredByMobi" />

        <PoweredByMobiFooter v-if="isFooterAvailable" />
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {onMounted, ref, computed} from '@vue/composition-api';
import {fetchMyTrips, getMyTrips} from '@/store/state/helpers';
import MainMenu from '../main-menu/main-menu';

Vue.use(VueCompositionAPI);

export default {
  name: 'AmexProfilePage',
  components: {MainMenu},

  setup() {
    const showPoweredByMobi = process.env.VUE_APP_THEME !== 'MOBI';
    const isHeaderVisible = process.env.VUE_APP_IS_HEADER_VISIBLE || false;
    const isRecentlyViewedSectionShown = process.env.VUE_APP_IS_RECENT_TRIPS_VISIBLE || false;
    const isFooterAvailable = process.env.VUE_APP_IS_FOOTER_VISIBLE || false;
    const loading = ref(true);

    onMounted(async () => {
      await fetchMyTrips();
      loading.value = false;
    });

    const trips = computed(() => {
      const asd = getMyTrips().filter((x) => !x.autoSaved);
      return asd;
    });

    return {
      showPoweredByMobi,
      isHeaderVisible,
      isFooterAvailable,
      isRecentlyViewedSectionShown,
      loading,
      trips,
    };
  },
};
</script>
